import { UserInfos } from './../interfaces/user-infos';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from '../services/users.service';

@Component({
    selector: 'app-user-modification',
    templateUrl: './user-modification.component.html',
    styleUrls: ['./user-modification.component.scss']
})
export class UserModificationComponent implements OnInit {

    @BlockUI() blockUI: NgBlockUI;
    @Input() id: string;
    @Input() role: string;

    userInfos: UserInfos = {
        id: "",
        firstName: "",
        lastName: "",
        fullName: "",
        email: "",
        isActive: false,
        idOrganization: "",
        idRole: "",
        role: "",
        lastConnect: "",
        shopName: "",
        image: "",
        description: "",
        isFittingShop: false,
        subDomainName: "",
        isPriseCote: false,
        isWeb: false,
        geolocation: "",
        telephoneNumber: "",
        shopCity: "",
        shopCountry: "",
        shopPostalCode: "",
        shopAddress: "",
        shopAddressSup: "",
        orderProcessing: 0,
        orderFinished: 0,
        network: [],

        providerName: "",
        phone: "",
        logo: "",
        adressCity: "",
        adressCountry: "",
        adressPostalCode: "",
        adressStreet: "",
        adressState: "",
        nbProviderTotal: 0,
        nbOrderRefusee: 0,
        nbProviderSold: 0,

        mangoUserId: "",
        mangoFirstName: "",
        mangoLastName: "",
        mangoEmail: "",
        birthday: null,
        nationality: "",
        residencecountry: "",

        walletId: "",
        IDENTITY_PROOF: {
            id: "",
            raison: "",
            status: ""
        },
        ADDRESS_PROOF: {
            id: "",
            raison: "",
            status: ""
        },

        bankAccountId: "",
        bankAddress1: "",
        bankAddress2: "",
        bankCity: "",
        bankCodepostal: "",
        bankCountry: "",
        bankDetailsIBAN: "",
        bankOwnerName: "",

        bankRegion: "",
        bankbIC: "",
    }

    newEmail: string;
    imageUpload: File;
    isValidImage: boolean;

    constructor(
        public activeModal: NgbActiveModal,
        private toastrService: ToastrService,
        private usersService: UsersService,
    ) { }

    ngOnInit(): void {
        this.getUserInfoById();
    }

    getUserInfoById(): void {
        this.blockUI.start('Loading');
        if (this.role === 'Provider') {
            this.usersService.getProviderDetailById(this.id).subscribe(
                (res) => {
                    if (res.success) {
                        this.userInfos = res.data as UserInfos;
                        this.newEmail = this.userInfos.email;
                        this.blockUI.stop();
                    }
                    else {
                        this.blockUI.stop();
                        if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
                            this.toastrService.error('Les paramètres sont invalides');
                        } else if (res.errorSet.includes('NOTFOUND')) {
                            this.toastrService.error('Utilisateur non trouvé');
                        } else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
                            this.toastrService.error('Une erreur serveur est survenue');
                        }
                    }
                },
                (error) => {
                    this.blockUI.stop();
                    // console.error(error);
                    this.toastrService.error('Une erreur s\'est produite');
                }
            );
        }
        else if (this.role === 'Shop') {
            this.usersService.getShopDetailById(this.id).subscribe(
                (res) => {
                    if (res.success) {
                        this.userInfos = res.data as UserInfos;
                        this.userInfos.phone = res.data.telephoneNumber;
                        this.newEmail = this.userInfos.email;
                        for (const key in this.userInfos) {
                            if (this.userInfos.hasOwnProperty(key) && this.userInfos[key] === undefined || this.userInfos[key] === "undefined") {
                                this.userInfos[key] = "Non spécifié";
                            }
                        }
                        this.blockUI.stop();
                    }
                    else {
                        this.blockUI.stop();
                        if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
                            this.toastrService.error('Les paramètres sont invalides');
                        } else if (res.errorSet.includes('NOTFOUND')) {
                            this.toastrService.error('Utilisateur non trouvé');
                        } else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
                            this.toastrService.error('Une erreur serveur est survenue');
                        }
                    }
                },
                (error) => {
                    this.blockUI.stop();
                    // console.error(error);
                    this.toastrService.error('Une erreur s\'est produite');
                }
            );
        }
    }

    processImage(event) {
        let image: File = event.target.files[0];
        if (image.size <= 5 * 2 ** 20) {
            this.imageUpload = image;
            let isValidImage = document.getElementById('isValidImage');
            isValidImage.style.display = "block";
        }
        else {
            let isNotValidImage = document.getElementById('isNotValidImage');
            isNotValidImage.style.display = "block";
        }
    }
    //Modify firstname,name, tel, email, domaine, description
    saveModify(): void {
        this.blockUI.start('Loading');

        if (this.role === 'Provider') {
            let data: FormData = new FormData();
            data.append("jwt", localStorage.getItem('token'));
            data.append("id", this.userInfos.id);
            data.append("firstName", this.userInfos.firstName);
            data.append("lastName", this.userInfos.lastName);
            data.append("previousEmail", this.userInfos.email);
            data.append("newEmail", this.newEmail);
            data.append("phone", this.userInfos.phone);
            data.append("company", this.userInfos.providerName);
            data.append("logo", this.imageUpload);
            data.append("description", this.userInfos.description);

            this.usersService.modifyProvider(data).subscribe(
                (res) => {
                    if (res.success) {
                        this.toastrService.success('Mise à jour réussie');
                        this.blockUI.stop();
                        this.activeModal.close();
                    } else {
                        this.blockUI.stop();
                        if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
                            this.toastrService.error('Les paramètres sont invalides');
                        } else if (res.errorSet.includes('NOTFOUND')) {
                            this.toastrService.error("L'utilisateur non trouvé");
                        } else if (res.errorSet.includes('EMAIL_EXIST')) {
                            this.toastrService.error("L'email existe déjà");
                        } else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
                            this.toastrService.error('Une erreur serveur est survenue');
                        } else if (res.errorSet.includes('CANNOT_UDPATE_LOGO') || res.errorSet.includes('SERVER_ERROR')) {
                            this.toastrService.error('Impossible de mettre à jour le logo');
                        }
                    }
                },
                (error) => {
                    this.blockUI.stop();
                    // console.error(error);
                    this.toastrService.error('Une erreur s\'est produite');
                }
            );
        } else if (this.role === 'Shop') {
            // const data = {
            // 	jwt: localStorage.getItem('token'),
            // 	id: this.userInfos.id,
            // 	firstName: this.userInfos.firstName,
            // 	lastName: this.userInfos.lastName,
            // 	previousEmail: this.userInfos.email,
            // 	newEmail: this.newEmail,
            // 	phone: this.userInfos.phone,
            // 	subDomainName: this.userInfos.subDomainName,
            // 	description: this.userInfos.description,
            // }

            let data: FormData = new FormData();
            data.append("jwt", localStorage.getItem('token'));
            data.append("id", this.userInfos.id);
            data.append("firstName", this.userInfos.firstName);
            data.append("lastName", this.userInfos.lastName);
            data.append("previousEmail", this.userInfos.email);
            data.append("newEmail", this.newEmail);
            data.append("phone", this.userInfos.phone);
            data.append("subDomainName", this.userInfos.subDomainName);
            data.append("logo", this.imageUpload);
            data.append("description", this.userInfos.description);
            data.append("shopName", this.userInfos.shopName);

            this.usersService.modifyShop(data).subscribe(
                (res) => {
                    if (res.success) {
                        this.toastrService.success('Mise à jour réussie');
                        this.blockUI.stop();
                        this.activeModal.close();
                    } else {
                        this.blockUI.stop();
                        if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
                            this.toastrService.error('Les paramètres sont invalides');
                        } else if (res.errorSet.includes('NOTFOUND')) {
                            this.toastrService.error("L'utilisateur non trouvé");
                        } else if (res.errorSet.includes('EMAIL_EXIST')) {
                            this.toastrService.error("L'email existe déjà");
                        } else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
                            this.toastrService.error('Une erreur serveur est survenue');
                        } else if (res.errorSet.includes('CANNOT_UDPATE_LOGO') || res.errorSet.includes('SERVER_ERROR')) {
                            this.toastrService.error('Impossible de mettre à jour le logo');
                        }
                    }
                },
                (error) => {
                    this.blockUI.stop();
                    // console.error(error);
                    this.toastrService.error('Une erreur s\'est produite');
                }
            );
        }
    }

    //Modify address
    saveModifyAddress(): void {
        this.blockUI.start('Loading');

        if (this.role === 'Provider') {

            const data = this.getAddressForm();

            if (!data) {
                this.blockUI.stop();
                return
            }

            this.usersService.modifyProviderAddress(data).subscribe(
                (res) => {
                    if (res.success) {
                        this.toastrService.success('Mise à jour réussie');
                        this.blockUI.stop();
                        this.activeModal.close();
                    } else {
                        this.blockUI.stop();
                        if (res.errorSet.includes('UNAUTHORIZED')) {
                            this.toastrService.error('Accès non authorisé');
                        } else if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
                            this.toastrService.error('Les paramètres sont invalides');
                        } else if (res.errorSet.includes('NOTFOUND')) {
                            this.toastrService.error("L'utilisateur non trouvé");
                        } else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
                            this.toastrService.error('Une erreur de serveur est survenue');
                        }
                    }
                },
                (error) => {
                    this.blockUI.stop();
                    // console.error(error);
                    this.toastrService.error('Une erreur s\'est produite');
                }
            );
        } else if (this.role === 'Shop') {

            const data = this.getAddressForm();

            if (!data) {
                this.blockUI.stop();
                return
            }

            this.usersService.modifyShopAddress(data).subscribe(
                (res) => {
                    if (res.success) {
                        this.toastrService.success('Mise à jour');
                        this.blockUI.stop();
                        this.activeModal.close();
                    } else {
                        this.blockUI.stop();
                        if (res.errorSet.includes('UNAUTHORIZED')) {

                        } else if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
                            this.toastrService.error('Les paramètres sont invalides');
                        } else if (res.errorSet.includes('NOTFOUND')) {
                            this.toastrService.error("L'utilisateur non trouvé");
                        } else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
                            this.toastrService.error('Une erreur serveur est survenue');
                        }
                    }
                },
                (error) => {
                    this.blockUI.stop();
                    // console.error(error);
                    this.toastrService.error('Une erreur s\'est produite');
                }
            );
        }
    }

    getAddressForm(): any {

        let data;

        if (this.role === 'Provider') {

            data = {
                jwt: localStorage.getItem('token'),
                id: this.userInfos.id,
                city: this.userInfos.adressCity,
                country: this.userInfos.adressCountry,
                postalCode: this.userInfos.adressPostalCode,
                address: this.userInfos.adressStreet,
            }

        } else if (this.role === 'Shop') {

            data = {
                jwt: localStorage.getItem('token'),
                id: this.userInfos.id,
                city: this.userInfos.shopCity,
                country: this.userInfos.shopCountry,
                postalCode: this.userInfos.shopPostalCode,
                address: this.userInfos.shopAddress,
            }
        }

        let INVALID_PARAMS = false;

        if (!data.city) {

            this.toastrService.error("Veuillez renseigner la ville");
            INVALID_PARAMS = true;
        }

        if (!data.country) {

            this.toastrService.error("Veuillez renseigner le pays");
            INVALID_PARAMS = true;
        }

        if (!data.postalCode) {

            this.toastrService.error("Veuillez renseigner le code postal");
            INVALID_PARAMS = true;
        }

        if (!data.address) {

            this.toastrService.error("Veuillez renseigner l'adresse");
            INVALID_PARAMS = true;
        }

        if (INVALID_PARAMS) {
            return false;
        }

        return data;
    }
}
